<template>
  <div class="main">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <router-link :to="'/jobs/edit/' + eventId" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
          <div class="h6">
            {{ eventData.event_name }}
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <h2>Days</h2>
            <div class="button-group">
              <router-link :to="'/jobs/' + eventId + '/days/create'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline desktop-button">
                <i class="fas fa-plus mr-x1"></i>Add a Day
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col">
          <table class="zero-table">
            <tr>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th></th>
            </tr>
            <tr v-for="(day, index) in days" :key="index">
              <td>{{ day.date }}</td>
              <td>{{ amPmConvert(day.start_time) }}</td>
              <td>{{ amPmConvert(day.end_time) }}</td>
              <td>
                <router-link :to="'/jobs/' + eventId + '/days/' + day.id" class="">
                  Details
                </router-link>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- modal town -->
    <router-link :to="'/jobs/' + eventId + '/days/create'" class="zero-btn zero-btn-fab zero-btn-primary bottom-right mobile-button">
      <i class="fas fa-plus"></i>
    </router-link>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import PageLoader from '@/components/PageLoader.vue'
import shared from '@/shared.js'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    PageLoader
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      eventId: '',
      eventData: {
        'event_name': '',
        'start_date': '',
        'end_date': '',
        'location': '',
        'floorplan_path': ''
      },
      days: [],
      uploadCSVmodal: false,
      errors: {
        'file': ''
      }
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.eventid) {
      this.eventId = this.$route.params.eventid
      this.getEvent()
    } else {
      this.$router.go(-1)
    }
  },
  methods: {
    getEvent () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.eventData = response.data
          this.days = response.data.days
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    uploadCSV () {
      this.isLoading = true
      let formData = new FormData()
      if (document.getElementById('csv-input').value !== '') {
        formData.append('csv', document.getElementById('csv-input').files[0])
      } else {
        formData.append('csv', null)
      }
      formData.append('id', this.eventId)
      axios
        .post(apiChoice + 'api/events/' + this.eventId + '/csv', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.uploadCSVmodal = false
          this.getEvent()
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    amPmConvert (time) {
      return shared.amPmConvert(time)
    },
    fileInputChange () {
      // I think for single file upload this isn't necessary...
      this.inputFile = this.$refs.csvinput.files
    },
    fileDragOver (event) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('drag-on-active')) {
        event.currentTarget.classList.add('drag-on-active')
      }
    },
    fileDragLeave (event) {
      // Clean up
      event.currentTarget.classList.remove('drag-on-active')
    },
    fileDrop (event) {
      event.preventDefault()
      this.$refs.csvinput.files = event.dataTransfer.files
      this.fileInputChange() // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.remove('drag-on-active')
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

.desktop-button{
  display: none;
}
.mobile-button{
  display: flex;
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .desktop-button{
    display: inline-block;
  }
  .mobile-button{
    display: none;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
